import { z } from 'zod';

const blankToNull = (value: unknown) => typeof value === 'string' && !value.trim() ? null : value;
const text = (max = 1000) => z.preprocess(blankToNull, z.string().trim().min(1).max(max).nullable()).optional();
const date = z.preprocess(blankToNull, z.string().regex(/^\d{4}-\d{2}-\d{2}$/).refine(value => {
  const parsed = new Date(value + 'T00:00:00Z');
  return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
}, '请输入有效日期 YYYY-MM-DD。').nullable()).optional();

/** Optional revision fields keep historical documents readable. */
export const insuranceHeaderShape = {
  policyNumber: text(200), policyIssueDate: date, assured: text(),
  insuredAmount: z.preprocess(blankToNull, z.string().regex(/^(?:0|[1-9]\d{0,14})(?:\.\d{1,2})?$/).nullable()).optional(),
  insuredAmountWords: text(), sailingDate: date, claimPayableAt: text(300),
  insuranceCoverage: text(), insuranceAdditionalRisks: text(), insuranceOtherRisks: text(),
  surveyAgent: text(), insuranceDeclaration: text(4000),
  applicantSignature: text(), insurerSignature: text(), insuranceRemarksDate: date,
};
export const insuranceTermNames = Object.keys(insuranceHeaderShape) as (keyof typeof insuranceHeaderShape)[];
export type InsuranceTerms = z.output<z.ZodObject<typeof insuranceHeaderShape>>;
